export const USE_TASKS_LIST = 'USE_TASKS_LIST';
export const GET_TASK_DETAILS = 'GET_TASK_DETAILS';
export const GET_NOTES = 'GET_NOTES';
export const TASKS_TABLE = 'TASKS_TABLE';
export const TASK_DETAILS_PAGE = 'TASKS_DETAILS_PAGE';
export const STATUSES = {
  WONT_COMPLETE: 'wontComplete',
  IN_PROGRESS: 'inProgress',
  COMPLETE: 'complete',
} as const;
